import script from "./EmailSupportButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailSupportButton.vue?vue&type=script&setup=true&lang=ts"

import "./EmailSupportButton.vue?vue&type=style&index=0&id=43a89185&scoped=true&lang=css"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43a89185"]])

export default __exports__